/* ============================================================
   CLAIREVIEW PEPTIDES — cp-global.js
   Shared lightweight behaviours for cp-* sections.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Scroll reveal (respects reduced motion) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.cp-reveal');
    if (!els.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cp-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Toast notification (shared) ---- */
  var toastHost;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'cp-toast-host';
      document.body.appendChild(toastHost);
    }
    var icon;
    if (opts.error) {
      icon = '<path d="M12 8v5M12 16.5v.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>';
    } else if (opts.gift) {
      icon = '<path d="M20 9v11H4V9M2 6h20v3H2zM12 20V6M12 6C10.9 6 8.5 5.7 8.5 4.2A1.7 1.7 0 0 1 12 4a1.7 1.7 0 0 1 3.5.2C15.5 5.7 13.1 6 12 6Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';
    } else {
      icon = '<path d="M20 7 10 17l-5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>';
    }
    var variant = opts.error ? ' cp-toast--error' : (opts.gift ? ' cp-toast--gift' : '');
    var t = document.createElement('div');
    t.className = 'cp-toast' + variant;
    t.setAttribute('role', 'status');
    /* A gift toast with a product image shows the unlocked item's
       thumbnail instead of the generic icon — this doubles as the
       fly-to-cart animation's start point. */
    var mediaHtml = opts.image
      ? '<span class="cp-toast__thumb" aria-hidden="true"><img src="' + opts.image + '" alt=""></span>'
      : '<span class="cp-toast__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none">' + icon + '</svg></span>';
    t.innerHTML =
      mediaHtml +
      '<span class="cp-toast__body"><span class="cp-toast__title"></span><span class="cp-toast__msg"></span></span>';
    t.querySelector('.cp-toast__title').textContent = opts.title || 'ADDED TO CART';
    t.querySelector('.cp-toast__msg').textContent = msg;
    toastHost.appendChild(t);
    lastToastMedia = t.querySelector('.cp-toast__thumb img, .cp-toast__icon');
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () {
      t.classList.remove('is-in');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 400);
    }, opts.error ? 5000 : 3600);
  }

  /* ---- Fly-to-cart animation ---- */
  var lastToastMedia;
  function bumpCartIcon() {
    var icon = document.querySelector('.cp-hdr__cart');
    if (!icon) return;
    icon.classList.remove('is-bump');
    void icon.offsetWidth; /* restart the animation on repeat triggers */
    icon.classList.add('is-bump');
    setTimeout(function () { icon.classList.remove('is-bump'); }, 550);
  }
  function flyToCart(imageUrl) {
    var cartIcon = document.querySelector('.cp-hdr__cart');
    if (!cartIcon) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!imageUrl || reduce) { bumpCartIcon(); return; }

    var startRect = lastToastMedia ? lastToastMedia.getBoundingClientRect() : null;
    if (!startRect || (startRect.width === 0 && startRect.height === 0)) {
      startRect = { left: window.innerWidth / 2 - 19, top: window.innerHeight / 2 - 19, width: 38, height: 38 };
    }
    var endRect = cartIcon.getBoundingClientRect();

    var clone = document.createElement('img');
    clone.src = imageUrl;
    clone.alt = '';
    clone.className = 'cp-fly-gift';
    clone.style.left = startRect.left + 'px';
    clone.style.top = startRect.top + 'px';
    clone.style.width = startRect.width + 'px';
    clone.style.height = startRect.height + 'px';
    document.body.appendChild(clone);

    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      bumpCartIcon();
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var dx = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
        var dy = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);
        clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)';
        clone.style.opacity = '0.15';
      });
    });
    clone.addEventListener('transitionend', settle);
    setTimeout(settle, 900); /* safety net if transitionend never fires */
  }

  /* ---- Cart count refresh ---- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cp-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  /* ---- AJAX add to cart (no redirect) ---- */
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('cp-btn--loading');
    }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        return r.json().then(function (data) { if (!r.ok) { throw data; } return data; });
      })
      .then(function (item) {
        refreshCartCount();
        var name = (item && item.product_title) || 'Item';
        toast(name + ' added to your cart', { title: 'ADDED TO CART' });
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add to cart.', { title: 'ERROR', error: true });
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('cp-btn--loading'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('form.cp-pcard__form, form.cp-pd__form')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  /* In the theme editor, sections re-render — re-scan each time. */
  function boot() {
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', initReveal);

  /* Expose for sections that inject content dynamically */
  window.CP = window.CP || {};
  window.CP.initReveal = initReveal;
  window.CP.toast = toast;
  window.CP.refreshCartCount = refreshCartCount;
  window.CP.flyToCart = flyToCart;
})();
